module.exports = __webpack_public_path__ + "static/media/blonde plex  promo 2 pic.8bfd5020.png";